import Handlebars from "handlebars-template-loader/runtime";

Handlebars.registerHelper("currentYear", () => new Date().getFullYear());
